import React, { useState, useEffect } from 'react';
import { QRCodeSVG } from 'qrcode.react';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3002';

function WhatsAppManager({ onClose }) {
  const [instances, setInstances] = useState([]);
  const [loading, setLoading] = useState(true);
  const [newInstanceName, setNewInstanceName] = useState('');
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    fetchInstances();
    const interval = setInterval(fetchInstances, 5000); // Rafraîchir toutes les 5 secondes
    return () => clearInterval(interval);
  }, []);

  const fetchInstances = async () => {
    try {
      const res = await fetch(`${API_URL}/api/whatsapp/instances`);
      const data = await res.json();
      setInstances(data);
      setLoading(false);
    } catch (e) {
      console.error('Erreur chargement instances:', e);
      setLoading(false);
    }
  };

  const addInstance = async () => {
    if (!newInstanceName.trim() || adding) return;

    setAdding(true);
    try {
      const res = await fetch(`${API_URL}/api/whatsapp/instances`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ name: newInstanceName.trim() })
      });
      if (res.ok) {
        setNewInstanceName('');
        fetchInstances();
      }
    } catch (e) {
      console.error('Erreur ajout instance:', e);
    } finally {
      setAdding(false);
    }
  };

  const removeInstance = async (instanceId) => {
    if (!window.confirm('Êtes-vous sûr de vouloir supprimer ce numéro WhatsApp ?')) return;

    try {
      await fetch(`${API_URL}/api/whatsapp/instances/${instanceId}`, {
        method: 'DELETE'
      });
      fetchInstances();
    } catch (e) {
      console.error('Erreur suppression instance:', e);
    }
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(0,0,0,0.8)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000
    }}>
      <div style={{
        background: 'var(--bg-secondary)',
        borderRadius: '16px',
        padding: '24px',
        maxWidth: '600px',
        width: '90%',
        maxHeight: '80vh',
        overflowY: 'auto'
      }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
          <h2 style={{ margin: 0 }}>📱 Gestion WhatsApp</h2>
          <button
            onClick={onClose}
            style={{
              background: 'transparent',
              border: 'none',
              color: 'var(--text-secondary)',
              fontSize: '1.5rem',
              cursor: 'pointer'
            }}
          >
            ✕
          </button>
        </div>

        {/* Ajouter un nouveau numéro */}
        <div style={{
          display: 'flex',
          gap: '10px',
          marginBottom: '20px',
          padding: '15px',
          background: 'var(--bg-primary)',
          borderRadius: '8px'
        }}>
          <input
            type="text"
            placeholder="Nom du numéro (ex: Support, Commercial...)"
            value={newInstanceName}
            onChange={(e) => setNewInstanceName(e.target.value)}
            onKeyPress={(e) => e.key === 'Enter' && addInstance()}
            style={{
              flex: 1,
              padding: '10px',
              background: 'var(--bg-secondary)',
              border: '1px solid var(--border)',
              borderRadius: '6px',
              color: 'var(--text-primary)'
            }}
          />
          <button
            onClick={addInstance}
            disabled={adding || !newInstanceName.trim()}
            style={{
              padding: '10px 20px',
              background: '#25d366',
              border: 'none',
              borderRadius: '6px',
              color: 'white',
              fontWeight: '600',
              cursor: adding ? 'wait' : 'pointer',
              opacity: adding || !newInstanceName.trim() ? 0.5 : 1
            }}
          >
            {adding ? '...' : '+ Ajouter'}
          </button>
        </div>

        {/* Liste des instances */}
        {loading ? (
          <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-muted)' }}>
            Chargement...
          </div>
        ) : instances.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '20px', color: 'var(--text-muted)' }}>
            Aucun numéro WhatsApp configuré. Ajoutez-en un ci-dessus.
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
            {instances.map(instance => (
              <div
                key={instance.instanceId}
                style={{
                  padding: '15px',
                  background: 'var(--bg-primary)',
                  borderRadius: '8px',
                  border: instance.connected ? '2px solid #25d366' : '2px solid var(--border)'
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '10px' }}>
                  <div>
                    <div style={{ fontWeight: '600', fontSize: '1.1rem' }}>
                      {instance.name}
                    </div>
                    {instance.phoneNumber && (
                      <div style={{ color: 'var(--text-muted)', fontSize: '0.9rem' }}>
                        +{instance.phoneNumber}
                      </div>
                    )}
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                    <span style={{
                      display: 'inline-flex',
                      alignItems: 'center',
                      gap: '5px',
                      padding: '4px 10px',
                      borderRadius: '12px',
                      fontSize: '0.8rem',
                      fontWeight: '600',
                      background: instance.connected ? 'rgba(37, 211, 102, 0.2)' : 'rgba(239, 68, 68, 0.2)',
                      color: instance.connected ? '#25d366' : '#ef4444'
                    }}>
                      <span style={{
                        width: '8px',
                        height: '8px',
                        borderRadius: '50%',
                        background: instance.connected ? '#25d366' : '#ef4444'
                      }}></span>
                      {instance.connected ? 'Connecté' : 'Déconnecté'}
                    </span>
                    <button
                      onClick={() => removeInstance(instance.instanceId)}
                      style={{
                        background: 'transparent',
                        border: '1px solid #ef4444',
                        color: '#ef4444',
                        padding: '4px 10px',
                        borderRadius: '6px',
                        cursor: 'pointer',
                        fontSize: '0.8rem'
                      }}
                    >
                      Supprimer
                    </button>
                  </div>
                </div>

                {/* QR Code si non connecté */}
                {!instance.connected && instance.qrCode && (
                  <div style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    padding: '20px',
                    background: 'white',
                    borderRadius: '8px',
                    marginTop: '10px'
                  }}>
                    <QRCodeSVG value={instance.qrCode} size={200} />
                    <p style={{ color: '#333', marginTop: '10px', fontSize: '0.9rem', textAlign: 'center' }}>
                      Scannez ce QR code avec WhatsApp<br />sur votre téléphone
                    </p>
                  </div>
                )}

                {!instance.connected && !instance.qrCode && (
                  <div style={{
                    textAlign: 'center',
                    padding: '20px',
                    color: 'var(--text-muted)',
                    background: 'var(--bg-tertiary)',
                    borderRadius: '8px',
                    marginTop: '10px'
                  }}>
                    En attente du QR code...
                  </div>
                )}
              </div>
            ))}
          </div>
        )}

        <div style={{
          marginTop: '20px',
          padding: '15px',
          background: 'rgba(251, 191, 36, 0.1)',
          borderRadius: '8px',
          fontSize: '0.85rem',
          color: 'var(--warning)'
        }}>
          ⚠️ <strong>Important:</strong> Utilisez des numéros dédiés au support. L'automatisation WhatsApp peut entraîner un ban de votre compte si mal utilisée.
        </div>
      </div>
    </div>
  );
}

export default WhatsAppManager;
